import React from 'react';
import Lottie from 'react-lottie';
import './Empty_Folder_Lottie.css';
import * as animationData from './Empty_Folder_Lottie.json';

function Empty_Folder_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Empty_Folder_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Empty_Folder_Lottie;